import '../styles/options.css';
import React, { useState } from 'react';
import BugWindow from './BugWindow';
import OptionButton from './OptionButton';
import { useEffect } from 'react';
import { registerGraphReaction, getGraphReactions } from '../utility/api';

function Options({ recenter, infoToggle, toggleStartScreen }) {

    const [isBugWindowOpen, setIsBugWindowOpen] = useState(false);
    const [netLikes, setNetLikes] = useState(0);
    const [liked, setLiked] = useState(false);

    useEffect(() => {
        // const urlParams = new URLSearchParams(window.location.search);
        // const graphName = urlParams.get('name');       
        // const likedGraphs = JSON.parse(localStorage.getItem('likedGraphs') || '{}');
        // setLiked(!!likedGraphs[graphName]);


        // getGraphReactions(graphName).then(reactions => {

        //     console.log("graphName: ", graphName);

        //     console.log("Reactions: ", reactions);

        //     var likes = reactions.likes || 0;
        //     var dislikes = reactions.dislikes || 0;
      
        //     var netLikes = likes - dislikes;
        //     if (netLikes < 0) {
        //       netLikes = 0;
        //     }

        //     setNetLikes(netLikes);
        //     console.log("Net likes: ", netLikes);
        //   }
        //   );
    }, []);

    function emailMe() {
        window.location.href = 'mailto:contactcharutak@gmail.com';
    }

    function openLink(link) {
        window.open(link, '_blank');
    }

    function onGraphLike() {
        const graphName = window.location.search.split('=')[1];
        // Check if the graph was already liked
        const likedGraphs = JSON.parse(localStorage.getItem('likedGraphs') || '{}');
        
        // Toggle the like status
        if (likedGraphs[graphName]) {
            delete likedGraphs[graphName]; // If liked, unlike it
        } else {
            likedGraphs[graphName] = true; // If not liked, like it
        }
        
        // Update localStorage
        localStorage.setItem('likedGraphs', JSON.stringify(likedGraphs));
        
        var reaction = liked ? 'dislike' : 'like';
        registerGraphReaction(graphName, reaction);
        setLiked(!liked);
    }

    function toggleBugWindow() {
        setIsBugWindowOpen(!isBugWindowOpen);
    }

    return (
        <div className="options">
            {/* <OptionButton
                name="love"
                onClick={() => onGraphLike()}
                isHighlighted={liked}
                tooltip={liked ? "Unlike Graph" : "Like Graph"}
            />
            {netLikes > 0 && <div className="likes">{netLikes}</div>} */}
            <OptionButton name="info" onClick={() => infoToggle()} tooltip="Toggle node info" />
            <OptionButton name="center" onClick={() => recenter()} tooltip="Recenter graph" />
            <OptionButton name="message" onClick={() => toggleBugWindow()} tooltip="Feedback / Bug" />
            <OptionButton name="logo" onClick={() => openLink('https://www.charutak.xyz')} tooltip="By Charu Tak" />
            {isBugWindowOpen && <BugWindow setIsBugWindowOpen={setIsBugWindowOpen} />}
        </div>
    );
}

export default Options;
